var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5835 9.50002C2.94183 9.50002 2.42266 10.025 2.42266 10.6667C2.42266 11.3084 2.94183 11.8334 3.5835 11.8334C4.22516 11.8334 4.75016 11.3084 4.75016 10.6667C4.75016 10.025 4.22516 9.50002 3.5835 9.50002ZM9.41683 9.50002C8.77516 9.50002 8.256 10.025 8.256 10.6667C8.256 11.3084 8.77516 11.8334 9.41683 11.8334C10.0585 11.8334 10.5835 11.3084 10.5835 10.6667C10.5835 10.025 10.0585 9.50002 9.41683 9.50002ZM4.22516 6.58335H8.571C9.0085 6.58335 9.3935 6.34419 9.59183 5.98252L11.8435 1.89335L10.8285 1.33335L8.571 5.41669H4.476L1.991 0.166687H0.0834961V1.33335H1.25016L3.35016 5.76085L2.56266 7.18419C2.13683 7.96585 2.69683 8.91669 3.5835 8.91669H10.5835V7.75002H3.5835L4.22516 6.58335Z",
    fill: "#A38C5E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.163639882c51505e41e8bed5104f5d08.svg";
export { ForwardRef as ReactComponent };